export enum STORAGE_TOKENS {
  USER_DATA = "@USER_DATA",
}
